import _extends from "@babel/runtime-corejs2/helpers/extends";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import mergeRefs from '../helpers/mergeRefs';
import { ContextConsumer } from './Context';

var SearchResults = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchResults, _React$Component);

  var _super = _createSuper(SearchResults);

  function SearchResults(props) {
    var _this;

    _classCallCheck(this, SearchResults);

    _this = _super.call(this, props);

    var _mergeRefs = mergeRefs(props.forwardedRef),
        ref = _mergeRefs.ref,
        setRef = _mergeRefs.setRef;

    _this.ref = ref;
    _this.setRef = setRef;
    props.setSearchResultsRef(ref);
    return _this;
  }

  _createClass(SearchResults, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          searchActive = _this$props.searchActive;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('cloud-ui-search-results', className),
        ref: this.setRef
      }, searchActive && children);
    }
  }]);

  return SearchResults;
}(React.Component);

export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var searchActive = _ref.searchActive,
        setSearchResultsRef = _ref.setSearchResultsRef;
    return /*#__PURE__*/React.createElement(SearchResults, _extends({}, props, {
      searchActive: searchActive,
      setSearchResultsRef: setSearchResultsRef,
      forwardedRef: ref
    }));
  });
});